import { render } from "./AddAdmin.vue?vue&type=template&id=f0357580&scoped=true"
import script from "./AddAdmin.vue?vue&type=script&lang=js"
export * from "./AddAdmin.vue?vue&type=script&lang=js"

import "./AddAdmin.vue?vue&type=style&index=0&id=f0357580&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0357580"]])

export default __exports__